import { Instagram, Facebook } from "lucide-react";
import { CONTACT } from "../i18n";
import XiaohongshuIcon from "./XiaohongshuIcon";

export default function Footer({ t }) {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#F5EFE6] border-t border-[#E8E1D9] py-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-3xl text-[#3E362E]">Danwei Huang</span>
            <span className="font-chinese text-xl text-[#1A9BC1]">源</span>
          </div>
          <p className="mt-3 text-[#7D746A] text-sm tracking-wide">
            {t.footer.tagline}
          </p>
          <p className="mt-6 text-[#8D7B68] text-sm italic font-serif max-w-sm leading-relaxed">
            {t.footer.group}
          </p>
        </div>

        <div>
          <div className="overline mb-4">{t.contact.addressLabel}</div>
          <p className="text-[#3E362E] text-sm leading-relaxed">
            {CONTACT.address}
          </p>
        </div>

        <div>
          <div className="overline mb-4">{t.nav.contact}</div>
          <p className="text-[#3E362E] text-sm break-all">{CONTACT.email}</p>
          <div className="mt-5 flex items-center gap-4">
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="w-10 h-10 rounded-full border border-[#1A9BC1]/40 text-[#1A9BC1] flex items-center justify-center hover:bg-[#1A9BC1] hover:text-white transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="w-10 h-10 rounded-full border border-[#C99A4E]/40 text-[#C99A4E] flex items-center justify-center hover:bg-[#C99A4E] hover:text-white transition-colors"
              data-testid="footer-facebook"
            >
              <Facebook size={18} />
            </a>
            <a
              href={CONTACT.xiaohongshu}
              target="_blank"
              rel="noreferrer"
              aria-label="Xiaohongshu"
              className="w-10 h-10 rounded-full border border-[#FF2442]/40 text-[#FF2442] flex items-center justify-center hover:bg-[#FF2442] hover:text-white transition-colors"
              data-testid="footer-xiaohongshu"
            >
              <XiaohongshuIcon size={22} />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-14 pt-6 border-t border-[#E8E1D9] flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#8D7B68] tracking-wider">
        <span>© {new Date().getFullYear()} Danwei Huang. {t.footer.rights}</span>
        <span className="flex items-center gap-2">
          <span className="font-chinese text-[#1A9BC1]">源</span>
          <span>Yuan · Origin · 本源</span>
        </span>
      </div>
    </footer>
  );
}
